module.exports = __webpack_public_path__ + "static/media/Aqi-Hazardous.c1a54c41.png";